import React from "react";
import Icon from "../icons/Icon";

function RemovableChip({ label, onRemove }) {
  return (
    <span className="chip-removable">
      <span className="chip-label">{label}</span>
      <button
        className="chip-remove"
        type="button"
        aria-label={`Remover ${label}`}
        onClick={onRemove}
      >
        <Icon name="x" strokeWidth={3} />
      </button>
    </span>
  );
}

export default RemovableChip;
